import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=aa971a84&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=aa971a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa971a84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa971a84')) {
      api.createRecord('aa971a84', component.options)
    } else {
      api.reload('aa971a84', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=aa971a84&scoped=true&", function () {
      api.rerender('aa971a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-297P2bNeMCZFn/JS/comp/Voucher.vue"
export default component.exports